unit NetScreenType;
{

/* Properties InstrumentItemList and TemperatureList added. */

/* Property InstrumentItemList removed. */

/* Initial. */

}

interface

uses
  CategoryItemListType, InstrumentItemListType, NetInstrumentItemListType, NetType,
  TemperatureListType;

type
  TNetScreenType = class
  private
    fNet: TNetType;
    fNetInstrumentItemList: TNetInstrumentItemListType;
    fCategoryItemList: TCategoryItemListType;
    fInstrumentItemList: TInstrumentItemListType;
    fTemperatureList: TTemperatureListType;
  public
    property Net: TNetType read fNet;
    property NetInstrumentItemList: TNetInstrumentItemListType read fNetInstrumentItemList;
    property CategoryItemList: TCategoryItemListType read fCategoryItemList;
    property InstrumentItemList: TInstrumentItemListType read fInstrumentItemList;
    property TemperatureList: TTemperatureListType read fTemperatureList;
  end;

implementation

end.
